



























import { Component, Emit, Vue } from 'vue-property-decorator';
import { publicIPAddressService } from './services/PublicIPAddressService';
import PriceWithCurrency from '@/components/common/PriceWithCurrency.vue';
@Component({
  props: ['price'],
  components: {
    PriceWithCurrency,
  },
})
export default class AddPublicIpAddressDialog extends Vue {
  workspaceId = 0;
  regionId = 0;
  priceModifier = 0.00001;
  hoursInMonth = 730;
  isLoading = false;
  @Emit()
  onClose() {
    return;
  }
  mounted() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.regionId = parseInt(this.$route.params.regionId, 10);
  }
  ipPrice(multiplier: number = 1) {
    if (!this.$props.price) {
      return 0;
    }
    return this.$props.price.cents * this.priceModifier * multiplier;
  }
  create() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    publicIPAddressService
      .reservePublicIPAddress(this.workspaceId, this.regionId)
      .then(() => {
        this.isLoading = false;
        this.onClose();
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
}
